export const allItemGroups = {
  name: "Все товары",
  itemgroupid: "0",
  parentid: "0",
  avaliable: 1,
  onlywhole: 1,
  importcode: "0",
  position: 0,
  groupid: "0",
};
